import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  hidden: true,
  openTour: false,
  scrollToBottom: false,
  usernameWidth: 0
};

const slice = createSlice({
  name: 'toggle',
  initialState,
  reducers: {
    switchToggle(state) {
      state.hidden = !state.hidden;
      state.type = null;
    },
    closeToggle(state) {
      state.hidden = true;
      state.type = null;
    },
    openTour(state, action) {
      state.openTour = action.payload;
    },
    toggleScrollToBottom(state, action) {
      state.scrollToBottom = action.payload;
    },
    usernameWidth(state, action) {
      state.usernameWidth = action.payload;
    }
  }
});

export const reducer = slice.reducer;

export const closeToggle = () => (dispatch) => {
  dispatch(slice.actions.closeToggle());
};

export const switchToggle = () => (dispatch) => {
  dispatch(slice.actions.switchToggle());
};

export const openTour = (value) => (dispatch) => {
  dispatch(slice.actions.openTour(value));
};

export const toggleScrollToBottom = (value) => (dispatch) => {
  dispatch(slice.actions.toggleScrollToBottom(value));
};

export const usernameWidth = (value) => (dispatch) => {
  dispatch(slice.actions.usernameWidth(value));
};
